import { render, staticRenderFns } from "./AuthorSection.vue?vue&type=template&id=0643feb9&"
import script from "./AuthorSection.vue?vue&type=script&lang=ts&"
export * from "./AuthorSection.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports